import { supabase } from '../config/supabase';
import { formatUserFacingDbError } from '../utils/formatUserFacingDbError';

/** HQ-only: delete fleet when no vehicles, drivers, trips, or jobs remain. */
export async function deleteFleetOperator(fleetOperatorId: string): Promise<void> {
  const { error } = await supabase.rpc('delete_fleet_operator', {
    p_fleet_operator_id: fleetOperatorId,
  });
  if (error) {
    throw new Error(formatUserFacingDbError(error, { action: 'delete' }));
  }
}
